// extracted by mini-css-extract-plugin
export default {"container":"LoadingView_container__8yGnw","fullscreen":"LoadingView_fullscreen__wr64H","message":"LoadingView_message__GMe8-"};